import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { get } from "lodash";
import { Tabs, Tab } from "react-bootstrap";
import { NotificationManager } from "react-notifications";

import { getFoodDetails, resetField } from "../../../../store/actions";
import { foodItemSteps } from "./formHelper";

const AddFoodItemTabs = ({ foodId, isAdmin, isView, isAdding, foodDetails, getFoodDetails, history, resetField }) => {
	const [activeTab, setActiveTab] = useState(0);
	const [isViewOnly, setisViewOnly] = useState(false);

	useEffect(() => {
		if (!foodId) {
			setActiveTab(0);
		} else {
			getFoodDetails(foodId);
			// if (!isAdding) {
			// 	setisViewOnly(true)
			// }
			// if (isView) {
			// 	setisViewOnly(true)
			// 	getPatientFoodDetails(`${foodId}`);
			// }
		}
	}, [foodId, getFoodDetails]);

	useEffect(() => {
		return () => {
			resetField("FoodDatabase.getFoodDetailsResult", {});
		};
	}, [resetField]);

	const saveAndPublish = (saved = true) => {
		saved && NotificationManager.success("Food item saved!", "", 5000);
		if (isAdmin) {
			history.push(`/nutrition/food-database/${foodDetails.id}/details`);
		} else {
			history.push(`/nutrition/myfood`);
		}
	};

	const renderTabs = () => {
		return foodItemSteps.map((step, i) => {
			const SpecificStep = step.component;
			return (
				<Tab key={step.id} eventKey={i} title={step.title} disabled={!foodId}>
					<SpecificStep
						isView={isAdmin ? false : isViewOnly}
						setActiveTab={setActiveTab}
						initialValues={foodDetails}
						foodId={foodId}
						saveAndPublish={saveAndPublish}
						refetchFoodItem={() => getFoodDetails(foodId)}
						history={history}
						isAdmin={isAdmin}
					/>
				</Tab>
			);
		});
	};

	return (
		<React.Fragment>
			<Tabs activeKey={activeTab} className="pt-2" onSelect={(tabNumber) => setActiveTab(Number(tabNumber))}>
				{renderTabs()}
			</Tabs>
			<div className="tab-status-text">Step {`${activeTab + 1} - ${foodItemSteps.length}`}</div>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	const { FoodDatabase, Auth } = state;
	return {
		foodDetails: get(FoodDatabase, "getFoodDetailsResult", {}),
		isAdmin: get(Auth, "isAdmin", false)
	};
};

const mapDispatchToProps = { getFoodDetails, resetField };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(AddFoodItemTabs));
